// TODO, improve and test this mini library

export function extract (xml, type) {
  switch (type) {
    case 'section':
      // extract all the sections and ignore the ones without an id
      return extractElements(xml, 'section').filter(section => section.id);
    case 'composite':
      // start by gathering all the compositeIds and for each parse its children
      return extractComposites(xml);
    case 'section-list':
      // TODO
      break;
    default:
      return extractElements(xml, type);
  }
}

export function extractComposites (xml) {
  var compositeNodes = xml.getElementsByTagName('composite');
  var parsedComposites = [];

  for (var i = 0; i < compositeNodes.length; ++i) {
    var cmpNode = compositeNodes[i];

    var baseComposite = extractAttributes(cmpNode);
    baseComposite.lines = [];

    // This is a fallback
    var children = cmpNode.children || cmpNode.childNodes;

    for (var j = 0; j < children.length; ++j) {
      var lineNode = children[j];

      var parsedLine = extractAttributes(lineNode);
      if (parsedLine) {
        parsedLine.type = lineNode.tagName;
        baseComposite.lines.push(parsedLine);
      }
    }

    parsedComposites.push(baseComposite);
  }

  return parsedComposites;
}

export function extractElements (xml, type) {
  var elements = xml.getElementsByTagName(type);
  var parsedResults = [];

  for (var i = 0; i < elements.length; ++i) {
    var el = elements[i];
    var attributes = extractAttributes(el);
    attributes && parsedResults.push(attributes);
  }

  return parsedResults;
}

// TODO, make this cross platform
export function extractAttributes (node) {
  if (!node || node.nodeName === '#text') { // this is for stripping childNodes text elements
    return false;
  }
  var attr = node.attributes;
  var parsedAttributes = {};

  for (var i = 0; i < attr.length; ++i) {
    var attrNode = attr[i];
    parsedAttributes[attrNode.name] = attrNode.value;
  }

  return parsedAttributes;
}

export function getChildElements (el, type) {
  var elements = [];
  // This is a fallback
  var children = el.children || el.childNodes;

  for (var j = 0; j < children.length; ++j) {
    var child = children[j];

    if (child.tagName === type) {
      elements.push(child);
    }
  }

  return elements;
}

export function getChildElement (el, type) {
  // This is a fallback
  var children = el.children || el.childNodes;

  for (var j = 0; j < children.length; ++j) {
    var child = children[j];

    if (child.tagName === type) {
      return child;
    }
  }

  return undefined;
}

export function getChildElementsAndE (el, type) {
  return getChildElements(getChildElement(el, type), 'E');
}

export function isParsedError (xml) {
  return extractElements(xml, 'parsererror').length;
}

// cross browser xml parser
export const parseXML = (function (window = {}) {

  const errorFN = () => {
    console.error('Sorry, no XML parser found');
    return new Error('Sorry, no XML parser found');
  };

  if (process.env.NODE_ENV === 'test') {
    window.DOMParser = require('xmldom').DOMParser;
  }

  if (typeof window.DOMParser === 'undefined') {
    return errorFN;
  }

  // default to window.DOMParser
  if (typeof window.DOMParser !== 'undefined') {
    return function (xmlStr) {
      return new window.DOMParser().parseFromString(xmlStr, 'text/xml');
    };
  }

  return errorFN;
})(window);



// WEBPACK FOOTER //
// ./frontend/react/sim/parser-mnx-geometry/utils/xml.js